import classNames from 'classnames';
import { NavLink, NavLinkProps } from 'react-router-dom';
import styles from './styles.module.css';
import { MouseEventHandler, ReactNode } from 'react';

type Props = {
  to: string;
  children?: NavLinkProps['children'];
  isClose: boolean;
  icon?: ReactNode;
  title?: string;
  onClick?: MouseEventHandler;
  badge?: boolean;
};

const Link = ({ to, isClose, icon, title, onClick, badge }: Props) => {
  return (
    <li className={classNames(styles.listItem)}>
      <NavLink
        className={({ isActive }) =>
          classNames(styles.link, isActive && styles.active)
        }
        to={to}
        onClick={onClick}
      >
        <div className={styles.icon}>
          {icon}
          {badge && <div className={styles.badge}></div>}
        </div>
        {isClose && <div>{title}</div>}
      </NavLink>
    </li>
  );
};

export default Link;
